import React from 'react';
import ruleModel from './model/ruleModel';
import { SelectBasePrototype } from 'clad';

export const SelectRuleType = React.forwardRef((props, ref) => {
    const { data, value, onChange, mode, placeholder } = props;
    const handleFetch = () => ruleModel.listRuleType();

    return (
        <SelectBasePrototype
            mode={mode}
            placeholder={placeholder || _('Select a rule type')}
            schema={{ idOption: 'id', option: 'name' }}
            fetch={handleFetch}
            onChange={onChange}
            value={value}
            data={data}
        />
    );
});
